var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabelTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 18 14",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.155.059h17.156v13.189h-17.156z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#021235",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.582 8.378c.51.002.877-.157 1.233-.314 1.295-.572 2.29-1.461 2.775-2.817.398-1.11-.002-1.957-1.013-2.282-.479-.153-.963-.164-1.44-.01-2.394.772-4.785 1.556-7.182 2.324-.326.104-.31.223-.14.468.71 1.02 1.74 1.347 2.909.91.863-.323 1.546-.891 2.157-1.56.181-.199.394-.3.618-.098.214.192.157.426.008.642-.03.043-.066.082-.102.121-.331.36-.695.682-1.09.971-.552.405-1.167.681-1.87.895.496.42.996.592 1.58.473.998-.203 1.713-.837 2.363-1.564.193-.215.404-.387.67-.158.278.238.16.489-.046.72-.405.45-.844.865-1.43 1.28m2.538-6.377c1.029.192 1.846.556 2.253 1.482.419.953.205 1.88-.293 2.723-1.21 2.048-3.024 3.089-5.414 3.114-.123.001-.292-.073-.36.06-.064.122.07.24.133.35.378.665.765 1.324 1.145 1.987.422.737.9.866 1.64.436.605-.35 1.208-.703 1.813-1.052 1.61-.93 3.22-1.857 4.83-2.785.236-.135.438-.278.449-.595.048-1.395.104-2.79.168-4.184.013-.293-.113-.47-.358-.598-1.228-.638-2.456-1.278-3.682-1.92-.187-.098-.375-.142-.565-.034-.56.318-1.115.643-1.76 1.016m7.192 1.487c-.048 1.422-.09 2.844-.147 4.265-.022.515-.23.932-.704 1.203-2.31 1.323-4.61 2.664-6.924 3.98-1.068.606-2.043.311-2.649-.748-.523-.915-1.05-1.828-1.578-2.739-.111-.19-.22-.373-.46-.46-1.855-.661-3.24-1.93-4.42-3.456-.403-.523-.393-.515.234-.717 2.133-.686 4.271-1.357 6.388-2.088.821-.283 1.521-.836 2.281-1.258.715-.397 1.415-.817 2.125-1.223.406-.233.827-.256 1.246-.038 1.322.686 2.643 1.373 3.96 2.067.483.254.663.69.648 1.212",
    mask: "url(#a)",
    transform: "translate(.291 .186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.995 3.655c-.302.029-.473.21-.472.489.001.278.16.467.473.468.288.001.515-.217.492-.495-.025-.295-.21-.438-.493-.462m-.092-.312c.571-.006 1.046.445 1.059 1.007.012.531-.49 1.033-1.037 1.037-.553.004-1.001-.436-1.01-.994-.011-.6.406-1.044.988-1.05"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelTag);
export default __webpack_public_path__ + "static/media/label-tag.80cd87331ecaa3d14bd564690558da84.svg";
export { ForwardRef as ReactComponent };